import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface SidebarState {
  pinned: boolean
  setPinned: (pinned: boolean) => void
  togglePinned: () => void
}

export const useSidebarStore = create<SidebarState>()(
  persist(
    (set) => ({
      pinned: false,
      setPinned: (pinned) => set({ pinned }),
      togglePinned: () => set((s) => ({ pinned: !s.pinned })),
    }),
    { name: 'sidebar-pinned' }
  )
)
